export const FeatureList = ({ items }) => {
  if (!items) return <span>loading</span>;

  return (
    <ul>
      {items.map((item, index) => (
        <li key={`${item}-${index}`}>{item}</li>
      ))}
    </ul>
  );
};
